import SideNav from './SideNav'
import Footer from './Footer'
import { Container } from 'react-bootstrap'
import Topbar from './top-bar/Topbar'
import { Outlet } from 'react-router-dom'
import Breadcrumbs from './page/Breadcrumbs'
import { useAppSelector } from '../../store/hooks'

const Layout: React.FC = () => {
    const sideNavToggled = useAppSelector(
        (state) => state.settings.sideNav.toggled
    )

    const topNavFixed: boolean = useAppSelector(
        (state) => state.settings.topNav.fixed
    )

    return (
        <div id="wrapper" className={`${sideNavToggled && 'sidebar-toggled'}`}>
            <SideNav />
            <div id="content-wrapper" className={`d-flex flex-column ${topNavFixed ? 'topNav-fixed' : ''}`}>
                <div id="content">
                    <Topbar />
                    <Breadcrumbs />
                    <Container fluid>
                        <Outlet />
                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Layout
